<template>
  <v-card height="26rem">
    <v-container>
      <v-row no-gutters align="center" class="px-3 mt-4 profile-menu">
        <v-col
          cols="8"
          class="title text-h6 text-md-h4 font-weight-bold mb-6 profile-title"
        >
          <v-icon color="#003088" x-large class="mb-2">fa-light fa-address-card</v-icon>
          My profile
        </v-col>
        <v-col cols="4" class="text-right mb-8">
          <slot name="dialogSize"></slot>
        </v-col>
      </v-row>
      <v-row>
        <v-container>
          <div class="d-flex">
            <div>
              <div class="ml-4 mb-10 profile-icon">
                <v-icon class="user-icon-size">fa-user-circle</v-icon>
              </div>
            </div>
            <div>
              <div class="text-subtitle-1 text-md-h6 font-weight-bold details-color">
                {{ details.description }}
              </div>
              <div>
                <div v-for="item in items" :key="item.id">
                  <b> {{ item.text }} valid to:</b>
                  <span v-if="item.id === 1">
                    <span :class="expiringSoon ? 'expiring-soon' : ''">
                      {{ getFormatedDate(details.expires, dateFormat) }}
                    </span>
                    {{ getExpirationDate(details.expires) }}
                  </span>
                  <span v-if="item.id === 2">
                    <span :class="expiringSoon ? 'expiring-soon' : ''">
                      {{ getFormatedDate(details.certexpires, dateFormat) }}
                    </span>
                    {{ getExpirationDate(details.certexpires) }}
                  </span>
                  <v-chip small color="#C4622D" class="expiring-text" v-if="expiringSoon">
                    Expiring soon
                  </v-chip>
                </div>
              </div>
            </div>
          </div>
        </v-container>
      </v-row>
      <v-row class="ml-2">
        <div class="text-h5 font-weight-bold">
          <v-btn icon v-if="showPermissions" @click="permissionsInfo()">
            <v-icon class="font-weight-normal">fa-chevron-down</v-icon>
          </v-btn>
          <v-btn icon v-else @click="permissionsInfo()">
            <v-icon>fa-chevron-right</v-icon>
          </v-btn>
          User permissions
        </div>
      </v-row>
      <v-container v-if="showPermissions">
        <div v-for="(role, index) in roles" :key="index">
          <div class="mt-2 ml-12">
            {{ role }}
          </div>
        </div>

        <v-row align="center" justify="end">
          <v-col cols="7"></v-col>
          <v-btn color="#006CA1" class="white--text mr-4" @click="closeProfile()">
            Close
          </v-btn>
        </v-row>
      </v-container>
    </v-container>
  </v-card>
</template>
<script>
import { getFormatedDate } from "@/Mixins/dateFormatMixin";
import * as constants from "@/config/constants";

export default {
  mixins: [getFormatedDate],
  props: ["details"],
  data() {
    return {
      dateFormat: "dddd, D MMMM YYYY [at] hh:mm [CET]",
      expiringSoon: false,
      showPermissions: false,
      items: [
        { text: "Officer", id: 1 },
        { text: "Certificate", id: 2 },
      ],
      roles: [],
    };
  },
  methods: {
    closeProfile() {
      this.$emit("closeProfile");
    },
    getExpirationDate(date) {
      let d1 = moment();
      let diff = moment(date).diff(d1, "days");
      // If less than 30
      if (diff < 30) {
        this.expiringSoon = true;
        loggg(date);
      } else {
        this.expiringSoon = false;
      }
    },
    permissionsInfo() {
      this.showPermissions = !this.showPermissions;
      this.roles = [];
      if (this.details.roles.includes(constants.CERT_ISSUE_ROLE)) {
        this.roles.push("Issue certificate");
      }
      if (this.details.roles.includes(constants.CERT_REVOKE_ROLE)) {
        this.roles.push("Revoke certificate");
      }
    },
  },
};
</script>
<style scoped lang="scss">
.expiring-soon {
  color: #c4622d !important;
}
.profile-title {
  color: #003088;
}
.profile-menu {
  border-bottom: 1px solid gainsboro;
}
.profile-icon {
  margin-right: 16px;
}
.user-icon-size {
  font-size: 5.5rem;
}
.details-color {
  color: #006ca1;
}
.expring-text {
  color: #ffffff;
}
</style>
